import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as DeleteOrganizationActions from '../actions/delete-organization.actions';
import {OrganizationsService} from '../../../services/api/organizations/organizations.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import * as OrganizationsActions from '../actions/organizations.actions';
import {Organization} from '../../../services/api/organizations/models/organization.model';


@Injectable()
export class DeleteOrganizationEffects {

  // noinspection JSUnusedGlobalSymbols
  deleteOrganization$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(DeleteOrganizationActions.deleteOrganization),
        concatMap((payload) =>
          this.organizationsService.deleteOrganization(payload.id)
            .pipe(
              map((data: Organization) => DeleteOrganizationActions.deleteOrganizationSuccess({data})),
              catchError(error => of(DeleteOrganizationActions.deleteOrganizationFailure({error})))
            )
        )
      );
  });

  // noinspection JSUnusedGlobalSymbols
  deleteOrganizationSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(DeleteOrganizationActions.deleteOrganizationSuccess),
        tap(() => this.snackBar.open('Organization successfully deleted', 'Success', {duration: 3000})),
        map(() => OrganizationsActions.loadOrganizations())
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly organizationsService: OrganizationsService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
